import styled from 'styled-components'

import { mq, sizes } from '../../theme'
import Buttons from '../Buttons'

export const PublicationGuideBigCard = styled.div`
  border-radius: 2rem;
  background: ${({ theme }) => theme.colors.brownBack};
`

export const Title = styled.h3`
  ${({ theme }) => theme.textStyles.firaSans2XlBold}
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin: 0;
  padding: 2rem 2rem 0 2rem;

  @media ${mq(sizes.tablet)} {
    padding: 4.5rem 4.5rem 0 4.5rem;
  }
`

export const Separator = styled.div`
  height: 3px;
  width: 100%;
  border-bottom: 3px dashed ${({ theme }) => theme.colors.greyContour};
  margin: 1.5rem 0;

  @media ${mq(sizes.tablet)} {
    margin: 4rem 0;
  }
`

export const Wrapper = styled.div`
  padding: 0 2rem 3rem 2rem;

  @media ${mq(sizes.tablet)} {
    padding: 0 4.5rem 3rem 4.5rem;
  }
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.montserratTextBase}
  @media ${mq(sizes.tablet)} {
  }
`

export const Btn = styled(Buttons)`
  margin-top: 3rem;

  @media ${mq(null, sizes.mobile)} {
    flex-direction: column-reverse;

    a,
    button {
      width: 100%;
    }
  }

  @media ${mq(sizes.mobile)} {
    a,
    button {
      flex: 1;
    }
  }
`
